import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import * as yup from 'yup';

const httpLink = createHttpLink({
  uri: `https://${process.env.REACT_APP_BACKEND}/api/graphql`,
  headers: {
    'X-Shopify-Storefront-Access-Token': `${process.env.REACT_APP_STOREFRONTAPI_ACCESS_TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const phoneRegex =
  /^((\+[1-9]{1,4}[ -]*)|(\([0-9]{2,3}\)[ -]*)|([0-9]{2,4})[ -]*)*?[0-9]{3,4}?[ -]*[0-9]{3,4}?$/;

export const RegisterSchema = yup.object().shape({
  firstname: yup
    .string()
    .required('Please Input FirstName')
    .min(2, 'Too Short')
    .max(30, 'Too Long'),
  lastname: yup
    .string()
    .required('Please Input LastName')
    .min(2, 'Too Short')
    .max(30, 'Too Long'),
  phonenumber: yup
    .string()
    .required('Please Input Phone')
    .matches(phoneRegex, 'Invalid phone number format'),
  email: yup.string().email().required('Email is required!'),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password is too short - should be 6 chars minimum'),
  confirmpassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required('Confirm Password is required'),
});

export const LoginSchema = yup.object().shape({
  email: yup.string().email().required('Email is required!'),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password is too short - should be 6 chars minimum'),
});

export const ForgetSchema = yup.object().shape({
  email: yup.string().email().required('Email is required!'),
});
